import VehicleLevel from '@/enums/VehicleLevel';
import VehicleType from '@/enums/VehicleType';
import VehicleStatusType from '@/enums/VehicleStatusType';
import IVehicle from './interfaces/vehicle.d';
import IImageCollectionSearchModel from '../image/interfaces/image-collection-search-model.d';
import Colour from './colour';

export default class Vehicle implements IVehicle {
  public manufacturerId!: number;

  public manufacturer!: string;

  public rangeId!: number;

  public rangeName!: string;

  public modelId!: number;

  public modelName!: string;

  public derivativeId!: number;

  public derivativeName!: string;

  public vehicleLevel!: VehicleLevel;

  public bodyStyleId!: number;

  public bodyStyleName!: string;

  public fuelTypeId!: string;

  public fuelTypeName!: string;

  public transmissionId!: string;

  public transmissionName!: string;

  public trimId!: string;

  public trimName!: string;

  public imageId!: number;

  public vehicleType!: VehicleType;

  public name!: string;

  public slugName!: string;

  public manufacturerName!: string;

  public manufacturerNameSlug!: string;

  public rangeNameSlug!: string;

  public modelNameSlug!: string;

  public derivativeNameSlug!: string;

  public vehicleStatusType!: VehicleStatusType;

  public images!: IImageCollectionSearchModel;

  public colours!: Colour[];
}
